import React, { useState } from 'react';
import './FacilityRow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function FacilityRow({ showDetail, facility }) {
  if (logComponent('FacilityRow')) { console.debug('FacilityRow rendered'); }

  const getStatusIcon = () => {
    if (logComponent('FacilityRow')) { console.debug('FacilityRow getStatusIcon'); }
    // For now, returning Active in all cases
    // In future this may return Active or Inactive
    // depending on the Facility
    let iconToUse = 'active';

    switch(iconToUse) {
      case 'active':
        return (
          <div className="Facility-Row__active">
            <FontAwesomeIcon 
              className="Facility-Row__active-icon" 
              icon="check-circle" />
            <span className="Facility-Row__status-text">Active</span>
          </div>);
      case 'inactive':
        return (
          <div className="Facility-Row__inactive">
            <FontAwesomeIcon 
              className="Facility-Row__inactive-icon" 
              icon="times-circle"/>
            <span className="Facility-Row__status-text">Active</span>
          </div>);      
      default: 
        return null;
    }
  }

  const getStatusIconNoText = () => {
    if (logComponent('FacilityRow')) { console.debug('FacilityRow getStatusIconNoText'); }
    // For now, returning Active in all cases
    // In future this may return Active or Inactive
    // depending on the Facility
    let iconToUse = 'active';

    switch(iconToUse) {
      case 'active':
        return (
            <FontAwesomeIcon 
              className="Facility-Row__active-icon" 
              icon="check-circle" />
        );
      case 'inactive':
        return (
            <FontAwesomeIcon 
              className="Facility-Row__inactive-icon" 
              icon="times-circle"/>
        );      
      default: 
        return null;
    }
  }

  const handleButtonClick = () => {
    if (logComponent('FacilityRow')) { console.debug('FacilityRow handleButtonClick'); }
    showDetail(facility);
  }

  return (
    <tr className="Facility-Row">
    <td className="Facility-Row__cell Facility-Row__salesforce-cell">{ facility.salesforceSiteId }</td>
    <td className="Facility-Row__cell Facility-Row__name-cell">
      <span className="Facility-Row__name">
        <span className="Facility-Row__name-text">{ facility.name }</span>
        <span className="Facility-Row__status-icon">{ getStatusIconNoText() }</span>
      </span>
      <span className="Facility-Row__salesforce-sm">Site ID: { facility.salesforceSiteId }</span>
    </td>
    <td className="Facility-Row__cell Facility-Row__status-cell">{ getStatusIcon() }</td>
    <td className="Facility-Row__cell Facility-Row__detail-cell">
      <button 
        className="Facility-Row__icon-btn"
        onClick={handleButtonClick}>
        <FontAwesomeIcon icon="ellipsis-h"></FontAwesomeIcon>
      </button>
    </td>
  </tr>
  );
}